module.exports = __webpack_public_path__ + "resource/static/img/logo.0069f9b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo.png
// module id = ZBJ4
// module chunks = 1